module.exports = __webpack_public_path__ + "img/lianwang-2.3baa23bd.jpg";